export default __webpack_public_path__ + "static/media/LIF3Small.7185fa51.svg";